import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import { Version5Service } from "./version5.service";
import *  as $ from 'jquery';
import * as backInter from 'app/auth/auth-data.model';
import { fuseAnimations } from '@fuse/animations';
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-version5',
  templateUrl: './version5.component.html',
  styleUrls: ['./version5.component.scss'],
  animations : fuseAnimations
})
export class Version5Component implements OnInit {

  idiomaActual:string;
  mailUsuario: string;
  urlCA = 'https://culture04.culturalgo.com:8443/FormBuilder/index.jsp?brk=AlexisTest&ccode=CayC&tok=ABCDE&usr=alexis.loredo@itbm.si&frm=audit2020&ver=1.0.0&sd=2020-02-18&ed=2020-03-28&per=2020-01&ul=1&fun=ce248f6f-3c60-45ed-821b-c5ac0617b753&lang=';
  urlSafe: SafeResourceUrl;
  urlEncontrada: boolean;
  productosContratadosInter : backInter.infoProductos;
  idProducto:string;

  constructor(
    private activatedRoute : ActivatedRoute,
    public authService: AuthService,
    public sanitizer: DomSanitizer,
    private translateSrv: TranslateService,
    private ca2Service: Version5Service,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
      private wizardService: WizardService,
  ) {
    //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
    lang_wizard.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    this.activatedRoute.params.subscribe(params => {
      //console.log('llego el parametro');
      // console.log(params);
      if(params.id){
        console.log("entro con ID");
        this.idProducto = params.id;
      }
      // this.idEmpresa = params.id;
      // this.idProducto = params.idprod;
      // this.idProducto_tmp=this.idProducto;
    });
  }

  ngOnInit() {
    this.traduceTextosTS();
  }

  // getURLCA(){
  //    this.wizardService.getProductos().subscribe((respuesta:backInter.infoProductos) => {
  //       console.log("Dude");
  //       console.log(respuesta);
  //       this.getURLCA2Version2(respuesta.productosCultureAuditV2[0].idCulture);
  //       let splitted2 = respuesta.productosCultureAuditV2[0].link.split("&");
  //       var splitted3 = respuesta.productosCultureAuditV2[0].link.split("lang=EN");
  //       if(localStorage.getItem('CultureTurquia') == 'Verdadero'){
  //         console.log("Si entro ");
  //         let pos  = parseInt(localStorage.getItem('Posculture'));
  //         let splitted2 = respuesta.productosCultureAuditV2[pos].link.split("&");
  //         splitted3 = respuesta.productosCultureAuditV2[pos].link.split("lang=EN");
  //       }
  //       console.log(splitted3);
  //       var statement1Part1 = splitted3[0];
  //       var statement1Part2 = 'lang='+this.idiomaActual;
  //       // console.log(statement1Part2);
  //       var statement1Part3 = splitted3[1];
  //       let urlCA5= statement1Part1+statement1Part2+statement1Part3;
  //       console.log(urlCA5);
  //
  //       // this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(urlCA5);
  //       // console.log(this.urlSafe);
  //
  //        this.urlEncontrada = true;
  //       }, error => {
  //       console.log("error", error);
  //     });
  // }

  //SEGUNDA VERSION
  getURLCA(){
    if(!this.idProducto){
      this.wizardService.getProductos().subscribe((respuesta:backInter.infoProductos) => {
        console.log("Dude");
        console.log(respuesta);
        //this.idProducto=respuesta.productosCultureAuditV2[0].idCulture;
        //CA TURQUIA
        if(localStorage.getItem('CultureTurquia') == 'Verdadero'){
          console.log("Si entro TURQUIA");
          let pos  = parseInt(localStorage.getItem('Posculture'));
          this.idProducto = respuesta.productosCultureAuditV2[pos].idCulture;
        }

        //CA MEXICO
        else if(localStorage.getItem('CultureMexico') == 'true'){
          console.log("Si entro a MX");
          let pos  = parseInt(localStorage.getItem('PoscultureMX'));
          this.idProducto = respuesta.productosCultureAuditV2[pos].idCulture;
        }else if(localStorage.getItem('CultureCH') == 'true'){
          console.log("Si entro a HK");
          let pos  = parseInt(localStorage.getItem('PoscultureCH'));
          console.log("Pos hk "+localStorage.getItem('CA_CHVERSION'));
          console.log("Versión hk"+  localStorage.getItem('CA_CHVERSION'));
          if( localStorage.getItem('CA_CHVERSION') == '2'){
            this.idProducto = respuesta.productosCultureAudit[pos].idCulture;
            console.log("Id hk"+this.idProducto);
          }else{
            this.idProducto = respuesta.productosCultureAuditV2[pos].idCulture;
          }

        }else{
          this.idProducto=respuesta.productosCultureAuditV2[0].idCulture;
        }
        this.getURLCA2Version2(this.idProducto);
      }, error => {
        console.log("error", error);
      });
    }
    else{
      this.getURLCA2Version2(this.idProducto);
    }
  }

  traduceTextosTS(){
    switch(this.translateSrv.currentLang){
      case 'es': case 'zh2': case 'tr': this.idiomaActual = this.translateSrv.currentLang.toUpperCase(); break;
      default: this.idiomaActual = 'EN';
    }
    this.getURLCA();
  }

  getURLCA2Version2(idProducto:string){
    this.idiomaActual = this.translateSrv.currentLang.toUpperCase();
    this.ca2Service.getURLCA2Version2(idProducto, this.idiomaActual).subscribe((respuesta:backInter.CultureAuditVersion2) =>{
    console.log(respuesta);
    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(respuesta.link);
    this.urlEncontrada = true;
    });
  }

}
